const logger = {
    info: (msg) => console.info(`INFO: ${msg}`),
    debug: (msg) => console.debug(`DEBUG: ${msg}`),
    warn: (msg) => console.warn(`WARN: ${msg}`),
    error: (msg) => console.error(`ERROR: ${msg}`)
};

export default logger
